
export default {
    name: 'SvgProhibitedBadge',
    props: {
        color: {
            type: String,
            default: '#A81C1E',
        },
    },
};
